<template>
    <div
        class="episodes-section py-10 bg-cover bg-blue-dark"
        :style="{
            backgroundImage: `url(${bgImage})`,
            backgroundColor
        }"
    >
        <h2 class="font-primary text-4xl text-white text-center">
            {{ title }}
        </h2>

        <div class="w-full">
            <slider :options="sliderOptions" :items="episodes">
                <template v-slot="{ item: episode, index }">
                    <episode
                        :episode="episode"
                        :episodes="episodes"
                        :index="index"
                    />
                </template>
            </slider>
        </div>
    </div>
</template>

<script>
import Episode from "./Episode";
import Slider from "./Slider";

export default {
    name: "episodes-section",

    components: { Slider, Episode },

    props: {
        title: {
            type: String,
            required: true
        },

        episodes: {
            type: Array,
            required: true,
            default: () => []
        },

        backgroundImage: {
            type: String,
            required: true
        },

        backgroundColor: {
            type: String,
            required: true
        }
    },

    computed: {
        sliderOptions() {
            return {
                slidesPerView: 1.5,
                centeredSlides: true,
                initialSlide: 1,
                watchSlidesVisibility: true,
                breakpoints: {
                    576: {
                        slidesPerView: 1,
                        centeredSlides: this.centerSlidesOnTabletAndDesktop,
                        initialSlide: 0
                    },
                    992: {
                        slidesPerView: 4,
                        centeredSlides: this.centerSlidesOnTabletAndDesktop,
                        initialSlide: 0
                    },
                    1200: {
                        slidesPerView: 5,
                        centeredSlides: this.centerSlidesOnTabletAndDesktop,
                        initialSlide: 0
                    }
                }
            };
        },

        bgImage() {
            return this.backgroundImage + ".webp"; //Queda pediente validar si el navegador soporta Webp
        },

        centerSlidesOnTabletAndDesktop() {
            // center slides on tablet and desktop when there's only one slide
            return this.episodes.length > 1 ? false : true;
        }
    }
};
</script>
